import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableDay = ({ id, children, disabled }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: id,
        data: {
            type: 'Day',
            dayId: id,
        },
        disabled: disabled
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        position: 'relative',
        zIndex: isDragging ? 999 : 'auto',
        opacity: isDragging ? 0.3 : 1,
        boxShadow: 'none',
        backgroundColor: 'transparent',
        cursor: isDragging ? 'grabbing' : 'default',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
        >
            {typeof children === 'function'
                ? children({ listeners, attributes })
                : children
            }
        </div>
    );
};
